'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExist = isExist;
exports.getSelectedMapByValue = getSelectedMapByValue;
exports.getNextValue = getNextValue;
/**
 * whether select value is exist
 */
function isExist(str) {
  return str !== undefined && str !== null;
}

// transform select data to selectedMap
function getSelectedMapByValue(value) {
  var type = Object.prototype.toString.call(value);
  var selectedMap = {};

  if (type === '[object Array]') {
    value.forEach(function (item) {
      if (Object.prototype.toString.call(item) === '[object Object]' && isExist(value.value)) {
        selectedMap[item.value] = true;
      } else {
        selectedMap[item] = true;
      }
    });
  } else if (type === '[object Object]' && isExist(value.value)) {
    selectedMap[value.value] = true;
  } else if (isExist(value)) {
    selectedMap[value] = true;
  }
  return selectedMap;
}

// get next select value when click one option Item
function getNextValue(value) {
  var dataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var multiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var triggerItem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var useDetailValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var selectedMap = getSelectedMapByValue(value);
  var triggerValue = triggerItem.value,
      triggerText = triggerItem.text;

  var nextSelectedState = !selectedMap[triggerValue];
  var eleItem = useDetailValue ? { text: triggerText, value: triggerValue } : triggerValue; // triggerItem may with fusion params
  var nextValue = null;

  if (nextSelectedState && multiple) {
    // for performance
    var curSelectIndex = dataSource.findIndex(function (dataItem) {
      return dataItem.value === triggerValue;
    });
    var pos = -1;

    nextValue = (value || []).slice();

    var _loop = function _loop(i, len) {
      if (selectedMap[dataSource[i].value]) {
        pos = nextValue.findIndex(function (dataItem) {
          return dataItem.value === dataSource[i].value;
        });
        return 'break';
      }
    };

    for (var i = curSelectIndex + 1, len = dataSource.length; i < len; i += 1) {
      var _ret = _loop(i, len);

      if (_ret === 'break') break;
    }
    if (pos > -1) {
      nextValue.splice(pos, 0, eleItem);
    } else {
      nextValue.push(eleItem);
    }
  } else if (nextSelectedState && !multiple) {
    nextValue = eleItem;
  } else if (!nextSelectedState && multiple) {
    nextValue = (value || []).reduce(function (cacheValue, item) {
      item.value !== triggerValue && cacheValue.push(item);
      return cacheValue;
    }, []);
  } else {
    nextValue = null;
  }

  nextSelectedState ? selectedMap[triggerValue] = true : delete selectedMap[triggerValue];
  return nextValue;
}